<template>
  <v-container mx-0 py-2 px-2 id="bet-filter">
    <div class="fields">
      <v-menu
        v-model="showStartDate"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="formatDate(startDate)"
            readonly
            hide-details
            v-bind="attrs"
            :label="expanded ? 'Start Date' : 'Date'"
            v-on="on"
            class="date-input"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="startDate"
          @input="showStartDate = false"
          v-on:input="updateDates()"
        ></v-date-picker>
      </v-menu>
      <v-menu
        v-if="expanded"
        v-model="showEndDate"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="formatDate(endDate)"
            readonly
            hide-details
            v-bind="attrs"
            label="End Date"
            v-on="on"
            class="date-input"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="endDate"
          @input="showEndDate = false"
          v-on:input="updateDates()"
        ></v-date-picker>
      </v-menu>
      <v-text-field
        v-if="expanded"
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        class="search-input"
        v-on:input="searchUpdated(search)"
      ></v-text-field>
    </div>
    <div class="buttons">
      <v-btn dark fab small color="grey" @click="toggleFilter">
        <v-icon>{{ expanded ? "mdi-filter-minus" : "mdi-filter-plus" }}</v-icon>
      </v-btn>

      <v-btn outlined color="primary" @click="refresh">
        Refresh
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import moment from "moment";
import _ from "lodash";

export default {
  name: "BetFilter",
  props: ["refresh"],
  data() {
    return {
      expanded: false,
      showStartDate: false,
      showEndDate: false,

      search: "",
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD")
    };
  },
  methods: {
    formatDate(d) {
      if (!d) return "";

      if (!this.expanded) {
        if (moment().isSame(d, "d")) return "Today";
        if (
          moment()
            .add(-1, "day")
            .isSame(d, "d")
        )
          return "Yesterday";
      }

      return d ? moment(d).format("Do MMM YYYY") : "";
    },
    searchUpdated(search) {
      this.debouncedSearchUpdated(search);
    },
    debouncedSearchUpdated: _.debounce(function(search) {
      this.$emit("update:search", search);
    }, 300),
    toggleFilter() {
      this.expanded = !this.expanded;
      this.search = "";
      this.$emit("update:search", this.search);

      if (!this.expanded && this.startDate !== this.endDate) {
        this.updateDates();
      }
    },
    updateDates() {
      if (!this.expanded) {
        this.endDate = this.startDate;
      }

      if (this.startDate > this.endDate) {
        this.endDate = this.startDate;
      }

      this.$emit("update:startDate", this.startDate);
      this.$emit("update:endDate", this.endDate);
      this.refresh();
    }
  }
};
</script>

<style lang="scss">
#bet-filter {
  max-width: unset;

  .headline {
    display: block;
    margin-right: 40px;
  }

  .fields {
    display: inline-block;
  }
  div.date-input {
    display: inline-block;
    width: 200px;
    margin-top: 8px;
    margin-right: 6px;
  }

  div.v-text-field {
    width: 150px;
    display: inline-block;
  }

  .search-input {
    margin-right: 20px;
  }

  .buttons {
    margin-top: 8px;
    display: inline-block;
  }
  .v-btn {
    margin-left: 10px;
  }
}
</style>
